export default ({ field, record }) => record[field];
